import i18next from 'i18next';
import jqueryI18next from 'jquery-i18next';
import i18nextHttpBackend from 'i18next-http-backend';
import languageEn from '../src/locales/en/translation';
import languageEs from '../src/locales/es/translation';

$(() => {
    const getLanguageFromUrl = () => {
        const path = window.location.pathname;
        const segments = path.split('/');
        let language;
        segments.forEach((segment) => {
            if (segment.length === 2) {
                language = segment;
            }
        });
        return language || 'en';
    };

    const language = getLanguageFromUrl();

    i18next
        .use(i18nextHttpBackend)
        .init({
            lng: language,
            fallbackLng: 'en',
            debug: true,
            resources: {
                en: {
                    translation: languageEn,
                },
                es: {
                    translation: languageEs,
                },
            },
        }, (err, t) => {
            if (err) return console.error(err);
            jqueryI18next.init(i18next, $, { useOptionsAttr: true });
            $('body').localize();
        });
});
